"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateConfigFiles = generateConfigFiles;
const tslib_1 = require("tslib");
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const path_1 = tslib_1.__importDefault(require("path"));
require("reflect-metadata");
const globalVars_1 = require("../common/globalVars");
const configGenerator_1 = require("../component/generator/configFiles/configGenerator");
const questionNames_1 = require("../question/questionNames");
async function generateConfigFiles(inputs) {
    const appManifestFilePath = inputs["manifest-file"];
    const projectPath = inputs[questionNames_1.QuestionNames.ProjectPath];
    const includePlayground = inputs["include-playground"];
    const includeLocalDebug = inputs["include-local"];
    const includeRemoteDeploy = inputs["include-remote"];
    const programmingLanguage = inputs["programming-language"];
    const appManifest = await teamsfx_api_1.AppManifestUtils.readTeamsManifest(path_1.default.join(projectPath, appManifestFilePath));
    const appName = appManifest.name.short;
    const features = detectAppFeatures(appManifest);
    const configComponents = [];
    if (includePlayground) {
        if (features.hasBot) {
            configComponents.push({ name: "playground", programmingLanguage });
        }
        else {
            await globalVars_1.TOOLS.ui?.showMessage("warn", `Playground is not supported for the current app manifest of ${appName}. Skipping Playground configuration file generation.`, false);
        }
    }
    if (includeLocalDebug) {
        configComponents.push({ name: "local", programmingLanguage });
    }
    if (includeRemoteDeploy) {
        configComponents.push({ name: "remote", programmingLanguage });
    }
    const context = (0, globalVars_1.createContext)();
    await configGenerator_1.configGenerator.run(context, projectPath, configComponents, { ...features, appName });
    return (0, teamsfx_api_1.ok)(undefined);
}
function detectAppFeatures(manifest) {
    const features = {};
    const manifestV1D24 = manifest;
    features["hasTab"] = manifest.staticTabs !== undefined && manifest.staticTabs.length > 0;
    features["hasBot"] = manifest.bots !== undefined && manifest.bots.length > 0;
    features["hasCopilot"] = manifestV1D24.copilotAgents !== undefined;
    features["hasMessageExtension"] =
        manifest.composeExtensions !== undefined && manifest.composeExtensions.length > 0;
    features["hasDeclarativeAgent"] =
        manifestV1D24.copilotAgents !== undefined &&
            manifestV1D24.copilotAgents.declarativeAgents !== undefined &&
            manifestV1D24.copilotAgents.declarativeAgents.length > 0;
    features["hasCustomEngineAgent"] =
        manifestV1D24.copilotAgents !== undefined &&
            manifestV1D24.copilotAgents.customEngineAgents !== undefined &&
            manifestV1D24.copilotAgents.customEngineAgents.length > 0;
    features["hasAzureBot"] = features["hasBot"] || features["hasMessageExtension"];
    features["supportCopilot"] = features["hasDeclarativeAgent"] || features["hasCustomEngineAgent"];
    return features;
}
//# sourceMappingURL=generateConfigFiles.js.map